import * as React from "react";
import ReactDOM from "react-dom";
import config from "../../../../config/config.json";
import { Link } from "react-router-dom";
import { getPageSEO } from "../functions";

import i18n from '../i18n';

class GDPR extends React.Component {
  constructor(props) {
    super(props);

    this.pageSEO = getPageSEO();

    document.title = this.pageSEO.title;
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", this.pageSEO.keywords);
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", this.pageSEO.description);

    document.querySelector('meta[name=\"title\"]').setAttribute('content', this.pageSEO.metaTitle);

    this.state = {
      detail: "",
      num: "1",
      from: "3",
      data: [],
      more_data: [],
      carousel: ""
    };

    this.loadMore = this.loadMore.bind(this);
    this.dowloadClicked = this.dowloadClicked.bind(this);
    this.posted = this.posted.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, { passive: true });

    // getReferences.request(this.setData);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    document.body.style.overflowY = "scroll";
  }

  loadMore() {
    this.setState({
      more_data: this.state.data.slice(9),
      load_more_option: { display: "none" }
    });
  }
  dowloadClicked(e) {
    var file = e.currentTarget.dataset.name;

    const data = {
      name: file
    };

    postLink.request(data, this.posted);
  }
  posted(response) {
    // console.log(response);
  }

  render() {
    return (
      <div className="main-container" id="main-container-gdpr">
        <div className="gdpr-container">
          <div className="gdpr-route">
            <b>Heatflow &gt; </b>GDPR
          </div>
          <h1 className="gdpr-nadpis">{i18n.t('gdpr.title')}</h1>
          <div className="gdpr-content" dangerouslySetInnerHTML={{ __html: i18n.t('gdpr.content') }}></div>
        </div>
      </div>
    );
  }
}

export default GDPR;
